<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="U8DeRefs" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" @change3="getTime">
					</Commondropdownlist>
				</div>
			</div>

			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<U8DeliveryOrderReporttable :tableData="tableData" :pageNo="pageindex" :pageSize="pageSize"
					:total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					@StockExport="StockExport">
				</U8DeliveryOrderReporttable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import U8DeliveryOrderReporttable from './components/U8DeliveryOrderReporttable.vue'
	import utils from '../../../common/utils'
	import {
		GetBackupReportList,
		GetBackupReportDownload
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			U8DeliveryOrderReporttable
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 10,
				tableData: [],
				formdata: [{
					inputdata: '',
					title: '选择年月',
					fontSize: '14px',
					color: '#333333',
					placeholder: '',
					types: '',
					inputtype: 'datemonth',
					width: '310px',
					options: []
				}],
				backupMonth: ''
			}
		},
		computed: {
			Currentday() {
				let date = new Date()
				let Currentday =
					`${date.getFullYear()}-${(date.getMonth()<=9?'0'+(date.getMonth()+ 1):date.getMonth()+1) }` //获取当前日期
				return Currentday
			}
		},
		mounted() {
			this.$refs.U8DeRefs[0].modelvalue = this.Currentday
			this.backupMonth = this.Currentday;
			this.GetBackupReportList();
		},
		methods: {
			async StockExport(e) {
				if (!e.length) {
					this.$message({
						type: "error",
						message: '请勾选'
					})
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await GetBackupReportDownload({
					brdiDs: e.map(item => item.BRDID)
				})
				this.$utils.downloadFile(res, `文件`, "rar", "application/rar")
				loading.close();
			},
			getTime(e) {
				this.pageindex = 1;
				this.backupMonth = e;
				this.GetBackupReportList();
			},
			// 列表
			async GetBackupReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await GetBackupReportList({
					backupMonth: this.backupMonth,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				loading.close();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.GetBackupReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.GetBackupReportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 37px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 40px;
	}
</style>